import { EditOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

import { ProcurementKnowledgeEditDialog } from '../ProcumentKnowledgeDialogs/ProcurementKnowledgeEditDialog';
import { useOpenClose } from '~/hooks';

interface ProcurementKnowledgeGridActionsProps {
  id: string;
}

export const ProcurementKnowledgeGridAction = ({ id }: ProcurementKnowledgeGridActionsProps) => {
  const [menuProps, handleOpen] = useOpenClose();

  const { t } = useTranslation('knowledgeRepository', { keyPrefix: 'ProcurementKnowledge.column.actions' });
  const label = t(`edit`);
  return (
    <Tooltip title={label} arrow placement="top">
      <>
        <GridActionsCellItem icon={<EditOutlined fontSize="small" />} label={label} onClick={handleOpen} />
        <ProcurementKnowledgeEditDialog docId={id} {...menuProps} />
      </>
    </Tooltip>
  );
};
